import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-inactividad-dialog',
  template: `
    <div class="dialog-container">
      <h2 mat-dialog-title>⚠️ Inactividad detectada</h2>
      <mat-dialog-content>
        <p>Tu sesión se cerrará automáticamente en <strong>{{ data.seconds }}</strong> segundos por inactividad.</p>
        <p>Haz clic en el botón si deseas continuar conectado.</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="continuar()">
          Seguir conectado
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .dialog-container {
      background: #f5f5f5;
      border-radius: 10px;
      padding: 20px;
      font-family: 'Segoe UI', sans-serif;
    }
    h2 {
      margin-top: 0;
      color: #c62828;
    }
    mat-dialog-content {
      font-size: 16px;
      color: #333;
    }
    mat-dialog-actions {
      margin-top: 20px;
    }
    button {
      font-weight: bold;
      padding: 8px 20px;
    }
  `]
})
export class InactividadDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InactividadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { seconds: number }
  ) {}

  continuar(): void {
    this.dialogRef.close(true); // Indica que el usuario desea continuar
  }
}
